import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[svHideCaret]'
})
export class HideCaretDirective implements OnInit {
  @Input() svHideCaret: boolean = true;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (this.svHideCaret) {
      // Find the ::after pseudo-element and hide it
      // Since we can't directly manipulate pseudo-elements with Angular,
      // we'll add a class that our CSS will target
      this.renderer.addClass(this.el.nativeElement, 'hide-dropdown-caret');
    }
  }
}
